// §1.6.1 / decision 5 (2026-07-07): the amendment reason cannot be generic — enforce a
// minimum length on the trimmed reason. Shared between the Amend modal (client) and the
// encounter re-authentication path (server); functions bundle @hb/shared via noExternal.
export const MIN_AMENDMENT_REASON_LENGTH = 10
